import { Controller } from '@hotwired/stimulus'

// This controller manages opening modals from buttons
export default class extends Controller {
  open (event) {
    // Get the modal ID from the data attribute
    const modalId = event.currentTarget.dataset.modalManagerTargetParam

    if (!modalId) {
      console.error('No modal ID provided')
      return
    }

    const modal = document.getElementById(modalId)
    if (!modal) {
      console.error(`Modal with ID ${modalId} not found`)
      return
    }

    // Get the modal's Stimulus controller
    const modalController = this.application.getControllerForElementAndIdentifier(modal, 'modal')

    if (modalController) {
      modalController.open()
    } else {
      // Fallback if no controller is attached yet
      this.openModalDirectly(modal)
    }
  }

  // Fallback method to open modal directly
  openModalDirectly (modal) {
    // Show the modal container
    modal.classList.remove('hidden')
    document.body.style.overflow = 'hidden'

    // Get the backdrop and modal content elements
    const backdrop = modal.querySelector('[data-modal-backdrop]')
    const modalContent = modal.querySelector('[data-modal-content]')

    // Start the animation
    requestAnimationFrame(() => {
      if (backdrop) {
        backdrop.classList.remove('opacity-0')
        backdrop.classList.add('opacity-50')
      }
      if (modalContent) {
        modalContent.classList.remove('opacity-0', 'translate-y-4')
        modalContent.classList.add('opacity-100', 'translate-y-0')
      }
    })
  }
}
